import ar from './ar'
import en from './en'
export default {
  ar,
  en,
}